export default __webpack_public_path__ + "static/media/02_Share-kai_Share.de57e96b.jpg";